/**
 * Local storage wrapper
 */
class LocalStorageWrapper {

	/**
	 * Returns a value from localStorage by provided key, or default value
	 *
	 * @param {string} key Local storage key
	 * @param {any} ifEmpty Value to return, if required value by key doesn't exist
	 */
	get(key, ifEmpty = []) {

		const data = localStorage.getItem(key);

		if (!data) {
			return ifEmpty;
		}
		
		try {
			return JSON.parse(data);
		}
		catch (e) {
			dump('Error parsing data from localStorage', e);
			return ifEmpty;
		}
	}

	set(key, value) {
		try {
			localStorage.setItem(key, JSON.stringify(value));
		}
		catch(e) {
			dump('Error setting a value to localStorage', 'key: ' + key, 'value: ' + value, e);
		}
	}

	remove(key) {
		localStorage.removeItem(key);
	}

	getOrSet() {
		dump('localstorage getOrSet');
	}

	/**
	 * Adds auth params to localStorage
	 *
	 * @param {Object} resp Response after login or user creation
	 */
	login(resp) {
		localStorage.name = resp.data.realName;
		localStorage.email = resp.data.email;
		localStorage.id = resp.data.id;
		localStorage.accountId = resp.data.accountId;
		
		const permissions = Array.isArray(resp.data.permissions) ? resp.data.permissions : [];
		this.set('permissions', permissions);
		
		const roles = Array.isArray(resp.data.roles) ? resp.data.roles : [];
		this.set('roles', roles);
	}

}

export default new LocalStorageWrapper();
